import { GET, POST } from './api'

export const ReadCompetitiveIntelligenceAccess = () => (
  GET('/competitive-intelligence/v1/access', true)
)

export const ReadCompetitiveIntelligenceOverview = () => (
  GET('/competitive-intelligence/v1/overview', true)
)

const queryString = query => {
  const params = new URLSearchParams()
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, value)
  })
  return params.toString() ? `?${params.toString()}` : ''
}

export const ReadCompetitiveIntelligenceResearch = query => (
  GET(`/competitive-intelligence/v1/research${queryString(query)}`, true)
)

export const ReadCompetitiveIntelligenceResearchDetail = id => (
  GET(`/competitive-intelligence/v1/research/${encodeURIComponent(id)}`, true)
)

export const ReadCompetitiveIntelligenceMarket = query => (
  GET(`/competitive-intelligence/v1/market${queryString(query)}`, true)
)

export const ReadCompetitiveIntelligenceAssistants = () => (
  GET('/competitive-intelligence/v1/assistants', true)
)

export const TriggerCompetitiveIntelligenceSync = () => (
  POST('/competitive-intelligence/v1/sync', {}, true)
)
